import { render, staticRenderFns } from "./case_order.vue?vue&type=template&id=761e0b1a&scoped=true"
import script from "./case_order.vue?vue&type=script&lang=js"
export * from "./case_order.vue?vue&type=script&lang=js"
import style0 from "./case_order.vue?vue&type=style&index=0&id=761e0b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761e0b1a",
  null
  
)

export default component.exports